// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59a0a433","453":"7d097a8f","667":"9096fa97"}[chunkId] + ".chunk.js";
};